/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChangeContractSpo } from './changeContractSpo.model';


export interface ContractSpo { 
    changeContractSpos?: Array<ChangeContractSpo>;
    contractId: number;
    endDate?: string;
    _new?: boolean;
    parcelId: number;
    podilCitatel?: number;
    podilJmenovatel?: number;
    price?: number;
    startDate?: string;
    subjectId: number;
    taxOwner?: number;
    typravKod: string;
    typravNazev?: string;
}

